import main from '../views/layouts/main.vue'


export default [
    {
        path: '/',
        name: 'default',
        meta: {
            authRequired: false,
            layout: main,
        },
        component: () => import('../views/pages/BomQuery/index'),
    },
    {
        path: '/tree',
        name: 'tree',
        meta: {
            authRequired: false,
            layout: main,
        },
        component: () => import('../views/pages/default/index.vue'),
    },
    {
        path: '/bomquery',
        name: 'bomquery',
        meta: {
            authRequired: false,
            layout: main,
        },
        component: () => import('../views/pages/BomQuery/index'),
    },
    {
        path: '/bomquery/:stockCode/:route',
        name: 'bomquery1',
        meta: {
            authRequired: false,
            layout: main,
        },
        component: () => import('../views/pages/BomQuery/index'),
    },
    {
        path: '/flatbom',
        name: 'flatbom',
        meta: {
            authRequired: false,
            layout: main,
        },
        component: () => import('../views/pages/FlatBom/index'),
    },
    {
        path: '/flatbom/:stockCode/:route',
        name: 'flatbom1',
        meta: {
            authRequired: false,
            layout: main,
        },
        component: () => import('../views/pages/FlatBom/index'),
    }
]